// extracted by mini-css-extract-plugin
export default {"modal":"_5rjBkVFhAggn6h7BUKY","modalOverlay":"YmLGP7EmXm7vvMFQ_ngC","modalTitle":"EY9Okdb3us6F6O8ZekIA","modalDescription":"KCa0GCi7ifaSjGdgWl5D","modalBtns":"m45JrUppLS0J1KTKFit3"};